import * as React from 'react';
import { SVGProps } from 'react';
export const MinusIcon = (props: SVGProps<SVGSVGElement>) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props} data-sentry-element="svg" data-sentry-component="MinusIcon" data-sentry-source-file="Minus.tsx">
    <rect x={4} y={11} width={16} height={2} rx={1} fill={props.fill || `currentColor`} data-sentry-element="rect" data-sentry-source-file="Minus.tsx" />
  </svg>;